import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface TransitProps {
  id: string;
  name: string;
}

export const useDownloadAllHouseConsignmentItems = () => {
  return useMutation({
    mutationFn: async ({ id, name }: TransitProps) => {
      const response = await request({
        path: `transits/${id}/download-all-house-consignment-items`,
        method: 'GET',
        authenticate: true,
        responseType: 'arraybuffer',
      });

      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}-all-houseConsignment-items.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
    onSuccess: () => {
      toast.success('Successfully downloaded the list!');
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading the house consignment items!`);
    },
  });
};
